import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

type UseCustomerIdFromUrlOptions = {
  mutateCustomers?: () => void | Promise<unknown>
  onApplied?: (customerId: string) => void
}

/** Μετά από νέο πελάτη: επιλογή από ?customerId=, revalidate λίστας, καθάρισμα URL. */
export function useCustomerIdFromUrl(
  setCustomerId: (id: string) => void,
  options?: UseCustomerIdFromUrlOptions,
) {
  const [searchParams, setSearchParams] = useSearchParams()
  const appliedRef = useRef<string | null>(null)
  const customerIdFromUrl = searchParams.get('customerId')?.trim() ?? ''
  const { mutateCustomers, onApplied } = options ?? {}

  useEffect(() => {
    if (!customerIdFromUrl || appliedRef.current === customerIdFromUrl) return
    appliedRef.current = customerIdFromUrl

    void (async () => {
      if (mutateCustomers) await mutateCustomers()
      setCustomerId(customerIdFromUrl)
      onApplied?.(customerIdFromUrl)

      const next = new URLSearchParams(searchParams)
      next.delete('customerId')
      setSearchParams(next, { replace: true })
    })()
  }, [
    customerIdFromUrl,
    mutateCustomers,
    onApplied,
    searchParams,
    setCustomerId,
    setSearchParams,
  ])
}
